import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AuthProvider from "./Components/context/AuthContext";
import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from './Scrolltop';
  // import { register as registerServiceWorker } from './Components/Login/serviceWorkerRegistration';
  // registerServiceWorker();

// Create the root using createRoot
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
      <ScrollToTop />
      <App />
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
